import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from './Table';
import { Api } from '../api';
import { Space } from 'antd';
//import { CategoriesFilter } from './CategoriesFilter';
import BasicTableFilter from './BasicTableFilter';




const columns = [
    {
        title: "id",
        sorter: true,
        dataIndex: "_id",
        width: '20%',
        key: "_id",
        render: (text: string) => {
            return (<Link to={`/blogs/update/${text}`}>{text}</Link>)
        }
    },
    {
        title: 'Title',
        dataIndex: 'title',
        key: "title",
        sorter: true,
        width: '20%',
    },
];

const BlogTable = () => {
    return (
        <Space style={{ width: '100%' }} direction="vertical">
            <Table
                tableId={ "blogsTable" }
              deleteApiCall={Api.blogs.delete}
                allowDelete={true}
                restoreApiCall={Api.blogs.restore}
                actions={(record: any) => (
                    <Link to={`/blogs/update/${record._id}`}>View</Link>
                )}
                Filter={BasicTableFilter}
             apiCall={Api.blogs.table} columns={columns} />
        </Space>
    )
};

export default BlogTable;